// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchImage_main__1RJXi {
    width: 100%;
    height: 100%;
}

.SearchImage_container__qNaYg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.SearchImage_container_left__EDhIm,
.SearchImage_container_right__tBI\\+N {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30%;
    height: 60%;
}

.SearchImage_container_right__tBI\\+N {
    width: 50%;
}

.SearchImage_container_middle__gFKqj {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 50%;
}

.SearchImage_container_item_header__RGDrh {
    width: 100%;
    height: 10%;
    text-align: center;
    font-size: 25px;
}

.SearchImage_container_left_content__E6nB1,
.SearchImage_container_right_content__dj7X5 {
    width: 100%;
    height: 90%;
    padding: 10px;
    border: 2px solid #ccc;
}

.SearchImage_container_right_content__dj7X5 {
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.SearchImage_container_right_content__dj7X5::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.SearchImage_container_right_content__dj7X5::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.SearchImage_container_right_content__dj7X5::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.SearchImage_item_box__2H9pg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 160px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
    border-radius: 6px;
}

.SearchImage_item_percent__CfGPT {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10%;
    height: 100%;
    font-size: 25px;
    font-weight: bold;
}

.SearchImage_item_img_box__kW8fK {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 68%;
    height: 100%;
}

.SearchImage_item_img__gVNME {
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
}

.SearchImage_item_text_box__Hu9dx {
    width: 20%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}

.SearchImage_item_text_name__hKUlb,
.SearchImage_item_text_category__-xUJc,
.SearchImage_item_text_brand__uKS\\+x {
    width: 100%;
    text-align: left;
}

.SearchImage_check_box__gepSn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
}

.SearchImage_search_type_box__HbH4i {
    width: 100%;
    height: 30%;
    padding: 10px;
    margin-bottom: 20px;
}

.SearchImage_sort_type_box__dbFz\\+,
.SearchImage_algorithm_type_box__Wsjlr {
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/imageSearch/components/SearchImage/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,gEAA6C,UAAU;IACnD,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,sEAAmD,WAAW;IAC1D,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n}\n\n.container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.container_left,\n.container_right {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 30%;\n    height: 60%;\n}\n\n.container_right {\n    width: 50%;\n}\n\n.container_middle {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 150px;\n    height: 50%;\n}\n\n.container_item_header {\n    width: 100%;\n    height: 10%;\n    text-align: center;\n    font-size: 25px;\n}\n\n.container_left_content,\n.container_right_content {\n    width: 100%;\n    height: 90%;\n    padding: 10px;\n    border: 2px solid #ccc;\n}\n\n.container_right_content {\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.container_right_content::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.container_right_content::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.container_right_content::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.item_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 160px;\n    border: 1px solid #ccc;\n    margin-bottom: 10px;\n    border-radius: 6px;\n}\n\n.item_percent {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 10%;\n    height: 100%;\n    font-size: 25px;\n    font-weight: bold;\n}\n\n.item_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 68%;\n    height: 100%;\n}\n\n.item_img {\n    max-width: 100%;\n    max-height: 100%;\n    cursor: pointer;\n}\n\n.item_text_box {\n    width: 20%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n}\n\n.item_text_name,\n.item_text_category,\n.item_text_brand {\n    width: 100%;\n    text-align: left;\n}\n\n.check_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.search_type_box {\n    width: 100%;\n    height: 30%;\n    padding: 10px;\n    margin-bottom: 20px;\n}\n\n.sort_type_box,\n.algorithm_type_box {\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `SearchImage_main__1RJXi`,
	"container": `SearchImage_container__qNaYg`,
	"container_left": `SearchImage_container_left__EDhIm`,
	"container_right": `SearchImage_container_right__tBI+N`,
	"container_middle": `SearchImage_container_middle__gFKqj`,
	"container_item_header": `SearchImage_container_item_header__RGDrh`,
	"container_left_content": `SearchImage_container_left_content__E6nB1`,
	"container_right_content": `SearchImage_container_right_content__dj7X5`,
	"item_box": `SearchImage_item_box__2H9pg`,
	"item_percent": `SearchImage_item_percent__CfGPT`,
	"item_img_box": `SearchImage_item_img_box__kW8fK`,
	"item_img": `SearchImage_item_img__gVNME`,
	"item_text_box": `SearchImage_item_text_box__Hu9dx`,
	"item_text_name": `SearchImage_item_text_name__hKUlb`,
	"item_text_category": `SearchImage_item_text_category__-xUJc`,
	"item_text_brand": `SearchImage_item_text_brand__uKS+x`,
	"check_box": `SearchImage_check_box__gepSn`,
	"search_type_box": `SearchImage_search_type_box__HbH4i`,
	"sort_type_box": `SearchImage_sort_type_box__dbFz+`,
	"algorithm_type_box": `SearchImage_algorithm_type_box__Wsjlr`
};
export default ___CSS_LOADER_EXPORT___;
